import React, { useEffect, useMemo } from "react";
import {
  Button,
  LinearProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  productsInLastCartSelector,
  summaryInLastCartSelector,
} from "../state/selectors/cartSelectors";

export default function PurchaseSummary() {
  const navigation = useNavigate();
  const { userLogged } = useSelector((state) => state.session);
  const productsInCart = useSelector(productsInLastCartSelector);
  const summaryInCart = useSelector(summaryInLastCartSelector);
  const state = useParams();

  const products = useMemo(
    () =>
      Array.isArray(productsInCart) && productsInCart?.length > 0
        ? productsInCart
        : state?.productsInCart || [],
    [productsInCart, state?.productsInCart]
  );

  const summary = useMemo(
    () =>
      summaryInCart && Object.keys(summaryInCart)?.length > 0
        ? summaryInCart
        : state?.summaryInCart || null,
    [summaryInCart, state?.summaryInCart]
  );

  // const updateQtys = () => {
  //   let result = 0;
  //   productsInCart.forEach((el) => {
  //     result = result + parseInt(el.product_uom_qty);
  //   });
  //   return result;
  // };

  const updateSubtotal = () => {
    let result = 0.0;
    productsInCart.forEach((el) => {
      result =
        result + parseFloat(el.product_uom_qty) * parseFloat(el.list_price);
    });
    return result.toFixed(2);
  };

  const updateDiscounts = () => {
    let result = 0.0;
    productsInCart.forEach((el) => {
      if (el.percent_price > 0) {
        result =
          result + (el.list_price - el.discounted_price) * el.product_uom_qty;
      }
    });
    return result.toFixed(2);
  };

  const updateTotal = () => {
    let result = updateSubtotal() - updateDiscounts();

    return result.toFixed(2);
  };

  useEffect(() => {
    if (!userLogged) {
      navigation("/");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <Stack spacing={1} style={{ alignItems: "center", padding: 8 }}>
        <CheckRoundedIcon color="primary" style={{ fontSize: "50px" }} />
        <Typography variant="h6" color="white">
          Compra realizada con éxito
        </Typography>
        {summary && (
          <Typography variant="body1" color="white" textAlign="center">
            Documento no válido como factura
            <br />
            N°: {summary?.name} <br />
            Fecha: {summary?.create_date}
          </Typography>
        )}
      </Stack>
      <LinearProgress variant="determinate" value={100} />

      {summary && products ? (
        <>
          <TableContainer style={{ maxHeight: "40vh" }}>
            <Table aria-label="spanning table">
              <TableBody style={{ overflow: "scroll" }}>
                {products?.map((row, index) => {
                  const nameProduct =
                    row.name.charAt(0) + row.name.slice(1).toLowerCase();
                  const priceWNDiscount =
                    `Precio u ${row.list_price}` +
                    (row.percent_price > 0 ? ` -${row.percent_price} %` : "");
                  const price_total =
                    row.list_price * row.product_uom_qty -
                    row.discount_amount * row.product_uom_qty;

                  return (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      key={index}
                    >
                      <TableCell>
                        {nameProduct}
                        <br />
                        {priceWNDiscount}
                      </TableCell>
                      <TableCell align="center">
                        {row.product_uom_qty}u
                      </TableCell>
                      <TableCell align="right">{price_total}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <LinearProgress variant="determinate" value={100} />

          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell size="small" colSpan={3} align="right">
                    Cantidad de productos
                  </TableCell>
                  <TableCell size="small" align="right">
                    {summary?.cart_quantity}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell size="small" colSpan={3} align="right">
                    Subtotal
                  </TableCell>
                  <TableCell size="small" align="right">
                    $ {updateSubtotal()}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell size="small" colSpan={3} align="right">
                    Descuento
                  </TableCell>
                  <TableCell size="small" align="right">
                    $ {updateDiscounts()}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell size="small" colSpan={3} align="right">
                    <Typography style={{ fontWeight: "bold" }} color="primary">
                      Total
                    </Typography>
                  </TableCell>
                  <TableCell size="small" align="right">
                    <Typography style={{ fontWeight: "bold" }} color="primary">
                      $ {updateTotal()}
                    </Typography>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell size="small" colSpan={3} align="right">
                    Medio de pago
                  </TableCell>
                  <TableCell size="small" align="right">
                    ****
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell size="small" colSpan={3} align="right">
                    N° de aprobación
                  </TableCell>
                  <TableCell size="small" align="right">
                    ********
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : null}

      <Button variant="text" color="primary">
        Gracias por ser parte de la experiencia RaffinGO
      </Button>

      <Button style={{ margin: "20px" }} onClick={() => navigation("/")}>
        VOLVER
      </Button>
    </div>
  );
}
